export default __webpack_public_path__ + "images/afc8cc5d3e16614aa11d0591bee5f5f4.svg";